import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=4321c50f&scoped=true"
import script from "./Tinymce.vue?vue&type=script&lang=js"
export * from "./Tinymce.vue?vue&type=script&lang=js"
import style0 from "./Tinymce.vue?vue&type=style&index=0&id=4321c50f&scoped=true&lang=scss"
import style1 from "./Tinymce.vue?vue&type=style&index=1&id=4321c50f&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321c50f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4321c50f')) {
      api.createRecord('4321c50f', component.options)
    } else {
      api.reload('4321c50f', component.options)
    }
    module.hot.accept("./Tinymce.vue?vue&type=template&id=4321c50f&scoped=true", function () {
      api.rerender('4321c50f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tinymce.vue"
export default component.exports